import React from 'react';
import { Route, Switch, Router, Redirect } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import OffersContainer from '../components/Offers/OffersContainer.jsx';
import RedirectToOfferContainer from '../components/organisms/RedirectToOfferContainer'
import SettingsContainer from '../forms/Settings/SettingsContainer';
import BetsTablesContainer from '../components/BetsTables/BetsTablesContainer';
import ArchiveTablesContainer from '../components/ArchiveTables/ArchiveTablesContainer';
import InRealizationTableContainer from '../components/InRealizationTable/InRealizationTableContainer.jsx';
import InvoicesTableContainer from '../components/InvoicesTable/InvoicesTableContainer';
import ConversationsTable from '../components/Conversations/ConversationsTable/ConversationsTable';
import ContentContainer from '../components/Content/ContentContainer';
import AdsContainer from '../components/Ads/AdsContainer';
import PromoteContainer from '../components/Ads/Promote/PromoteContainer';
import CreatePromotionFormContainer from '../components/Ads/CreatePromotionForm/CreatePromotionFormContainer';
import AdNew from '../components/Ads/AdNew';
import Modal from '../components/Modal/Modal';
import history from '../store/history';

import {
  BROWSE,
  MY_BETS,
  IN_REALIZATION,
  ACCEPTED,
  navigationMapping,
  BUY_NOW
} from '../consts/navigation';
import AdUpade from '../components/Ads/AdUpade';
import UpdatePromotionFormContainer from '../components/Ads/UpdatePromotionFormContainer/UpdatePromotionFormContainer';
import BuyNowOffersContainer from '../components/BuyNowOffers/BuyNowOffersContainer';
import SignInForm from '../components/Authentication/SignInForm';
import NewPasswordFrom from '../components/Authentication/NewPasswordFrom';
import ResetPasswordForm from '../components/Authentication/ResetPasswordForm';
import OfferDetailsContainer from '../components/organisms/OfferDetailsContainer';

const Routers = () => {
  return (
    <Router history={history}>
      <Layout>
        <Modal />
        <Switch>
          <Redirect from="/" exact to={navigationMapping[BROWSE].table_url} />
          <Redirect from="/dashboard" exact to={navigationMapping[BROWSE].table_url} />
          <Route path={`${navigationMapping[BROWSE].details_url}/:offerId`} component={OfferDetailsContainer} />
          <Route path={`${navigationMapping[MY_BETS].details_url}/:offerId`} component={OfferDetailsContainer} />
          <Route path={`${navigationMapping[IN_REALIZATION].details_url}/:offerId`} component={OfferDetailsContainer} />
          <Route path={`${navigationMapping[ACCEPTED].details_url}/:offerId`} component={OfferDetailsContainer} />
          <Route path={`${navigationMapping[BUY_NOW].details_url}/:offerId`} component={OfferDetailsContainer} />
          <Route path={navigationMapping[BROWSE].table_url} component={OffersContainer} />
          <Route path="/dashboard/buy-now" component={BuyNowOffersContainer} />
          <Route path="/dashboard/bets" component={BetsTablesContainer} />
          <Route path={navigationMapping[IN_REALIZATION].table_url} component={InRealizationTableContainer} />
          <Route path="/dashboard/archive" component={ArchiveTablesContainer} />
          <Route path="/dashboard/invoices" component={InvoicesTableContainer} />
          <Route path="/dashboard/conversations" component={ConversationsTable} />
          <Route path="/dashboard/content" component={ContentContainer} />
          <Route exact path="/dashboard/ads/:adId/promote" component={PromoteContainer} />
          <Route exact path="/dashboard/ads/:adId/promote/:channelId" component={CreatePromotionFormContainer} />
          <Route path="/dashboard/ads/new-ad" component={AdNew} />
          <Route path="/dashboard/ads/update/:adId" component={AdUpade} />
          <Route path="/dashboard/promotions/update/:promotionId" component={UpdatePromotionFormContainer} />
          <Route path="/dashboard/ads" component={AdsContainer} />
          <Route path="/dashboard/settings" component={SettingsContainer} />
          <Route path="/dashboard/auth/sign-in" component={SignInForm} />
          <Route path="/dashboard/auth/new-password" component={NewPasswordFrom} />
          <Route path="/dashboard/auth/reset-password/:token" component={ResetPasswordForm} />
          <Route path="/dashboard/auth/reset-password-by-token/:token" component={ResetPasswordForm} />
          <Route path="/dashboard/offers/:offerId" component={RedirectToOfferContainer} />

        </Switch>
        <style jsx="true" global="true">{`
          html, body, div, span, applet, object, iframe,
          h1, h2, h3, h4, h5, h6, p, blockquote, pre,
          a, abbr, acronym, address, big, cite, code,
          del, dfn, em, font, img, ins, kbd, q, s, samp,
          small, strike, strong, sub, sup, tt, var,
          b, u, i, center,
          dl, dt, dd, ol, ul, li,
          fieldset, form, label, legend,
          table, caption, tbody, tfoot, thead, tr, th, td {
            background: transparent;
            border: 0;
            margin: 0;
            padding: 0;
            vertical-align: baseline;
          }
          html, body {
            height: 100%;
          }
          .row, .col-md-10, .col-md-2, .col-md-7, .col-md-12, .col-md-5 {
            margin-right: 0;
            margin-left: 0;
            padding-left: 0;
            padding-right: 0;
          }
          body {
            font-family: 'Montserrat', 'Open Sans', sans-serif;
            font-size: 13px;
            color: #8a8695;
            background: #f9f9fa;
          }
          .container {
            height: 100%;
            background-color: white;
            padding-left: 0;
            padding-right: 0;
          }
          label {
            width: 100%;
            margin-bottom: 5px;
            font-size: 13px;
            font-weight: 400;
            color: #b0acb7;
          }
          button.button-default:not([disabled]) {
            background-color: #57C2F0;
            color: #FFF;
            border: 1px solid #57C2F0;
            transition: border .3s;
          }
          button.button-default:not([disabled]):hover {
            border-color: #1362b1;
          }
          .btn {
            padding: 12px 22px;
            border: 1px solid #57c2ef;
            border-radius: 5px;
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            display: flex;
            align-items: center;
            margin: 0 auto;
          }
          .btn.transparent {
            color: #57c2ef;
            background: transparent;
            transition: 150ms all linear;
          }
          .btn.transparent:hover {
            color: #fff;
            background: #57c2ef;
          }
          .btn.blue {
            color: #fff;
            background: #57c2ef;
            transition: 150ms all linear;
          }
          .btn.blue:focus {
            outline: none;
            box-shadow: none;
          }
          .btn.blue:hover {
            border: 1px solid blue;
          }
          .col-centered {
            float: none;
            margin: 0 auto;
          }
        `}</style>
      </Layout>
    </Router>
  );
};

export default Routers;
